import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import {useMutation} from '@apollo/react-hooks'
import {Form, Input, message} from 'antd'
import Button from 'components/shared/Button'

const updateEstateMutation = gql`
  mutation UpdateEstate($input: UpdateEstateInput!) {
    UpdateEstate(input: $input) {
      estate {
        id
        customerRef
      }
    }
  }
`

const CustomerRef = ({customerRef, estateId}) => {
  const [form] = Form.useForm()
  const [updateEstate, {loading: submitting}] = useMutation(updateEstateMutation)

  useEffect(() => {
    form.resetFields()
  }, [form, customerRef])

  function onSubmit(values) {
    updateEstate({
      variables: {
        input: {
          estateId,
          ...values,
        }
      }
    }).then(() => {
      message.success('Oppdragsnummer oppdatert')
    })
    .catch((err) => {
      message.error('Noe gikk galt med oppdatering av oppdragsnummer. Prøv igjen senere.')
    })
  }

  return (
    <Form form={form} layout="vertical" initialValues={{customerRef}} onFinish={onSubmit}>
      <Form.Item
        name="customerRef"
        label="Oppdragsnummer"
      >
        <Input />
      </Form.Item>
      <Form.Item shouldUpdate>
        {() => (
          <Button
            type="action"
            htmlType="submit"
            loading={submitting}
            disabled={
              submitting ||
              !form.isFieldsTouched(true)
            }
          >
            {submitting ? 'Lagrer...' : 'Lagre endringer'}
          </Button>
        )}
      </Form.Item>
    </Form>
  )
}

CustomerRef.propTypes = {
  customerRef: PropTypes.string,
  estateId: PropTypes.string.isRequired,
}

export default CustomerRef
